<!-- Main container -->
<div class="container-tlhex">

	<canvas-tabset />
	<!--NOTA: quando stiamo visualizzando la schermata AP o Lateral, bisogna aggiungere al seguente div la classe "wrapper-single-img". Se siamo su Multiple, invece, deve scomparire -->
	<div class="wrapper-ap">
		<div class="content">

			<!-- SINGLE VIEW FOCUS -->
			@if (activeViewState !== activeViewStateEnum.multiple) {
			<div class="divider-single">
				<div class="top"></div>
				<div class="bottom"></div>
				<div class="left"></div>
				<div class="right"></div>
			</div>
			}

			<!-- CENTRAL DIVIDER -->
			@if (activeViewState == activeViewStateEnum.multiple) {
			<div class="divider-multiple"></div>
			}

			<!-- LEFT FOCUS -->
			<div [class.selected]="activeViewState == activeViewStateEnum.multiple && activeView == activeViewEnum.AP">
				<div class="line top-left"></div>
				<div class="line left"></div>
				<div class="line bottom-left"></div>
			</div>
			<!-- RIGHT FOCUS -->
			<div [class.selected]="activeViewState == activeViewStateEnum.multiple && activeView == activeViewEnum.LT">
				<div class="line top-right"></div>
				<div class="line right"></div>
				<div class="line bottom-right"></div>
			</div>

			<!-- AP VIEW LABELS -->
			@if (activeViewState == activeViewStateEnum.AP) {
			<div>
				<div class="btn-xray left">
					{{ isLeft ? labels().CANVAS3D_COMPONENT_MEDIAL_LABEL : labels().CANVAS3D_COMPONENT_LATERAL_LABEL }}</div>
				<div class="btn-xray right">
					{{ isLeft ? labels().CANVAS3D_COMPONENT_LATERAL_LABEL : labels().CANVAS3D_COMPONENT_MEDIAL_LABEL }}</div>
			</div>
			}

			<!-- LT VIEW LABELS -->
			@if (activeViewState == activeViewStateEnum.LT) {
			<div>
				<div class="btn-xray left">
					{{ isLeft ? labels().CANVAS3D_COMPONENT_POSTERIOR_LABEL : labels().CANVAS3D_COMPONENT_ANTERIOR_LABEL }}</div>
				<div class="btn-xray right">
					{{ isLeft ? labels().CANVAS3D_COMPONENT_ANTERIOR_LABEL : labels().CANVAS3D_COMPONENT_POSTERIOR_LABEL }}</div>
			</div>
			}

			<!-- MULTIPLE VIEW LABELS -->
			@if (activeViewState == activeViewStateEnum.multiple) {
			<div>
				<div class="multiple-left">
					<div class="btn-xray left">
						{{ isLeft ? labels().CANVAS3D_COMPONENT_MEDIAL_LABEL : labels().CANVAS3D_COMPONENT_LATERAL_LABEL }}</div>
					<div class="btn-xray right">
						{{ isLeft ? labels().CANVAS3D_COMPONENT_LATERAL_LABEL : labels().CANVAS3D_COMPONENT_MEDIAL_LABEL }}</div>
				</div>
				<div class="multiple-right">
					<div class="btn-xray left">
						{{ isLeft ? labels().CANVAS3D_COMPONENT_POSTERIOR_LABEL : labels().CANVAS3D_COMPONENT_ANTERIOR_LABEL }}
					</div>
					<div class="btn-xray right">
						{{ isLeft ? labels().CANVAS3D_COMPONENT_ANTERIOR_LABEL : labels().CANVAS3D_COMPONENT_POSTERIOR_LABEL }}
					</div>
				</div>
			</div>
			}

			<!-- CALIBRATION FACTOR -->
			@if (isMultipleAP) {
			<div class="wrapper-calibration left">
				{{ labels().CANVAS3D_COMPONENT_CALIBRATION_FACTOR }}
				{{ scaleFactorAP | number:'1.2-2' }}</div>
			} @else {
			<div class="wrapper-calibration right">
				{{ labels().CANVAS3D_COMPONENT_CALIBRATION_FACTOR }}
				{{ (activeViewState == activeViewStateEnum.AP ? scaleFactorAP : scaleFactorLT) | number:'1.2-2' }}
			</div>
			}

			<!--RIGHT WIDGET ZOOM SINGLE VIEW -->
			@if (!isMultipleAP) {
			<div class="widget-zoom">
				<div class="btn-zoom" [title]="labels().CANVAS3D_COMPONENT_FIT_TO_VIEW" (click)="fitToView()"
					(keypress)="fitToView()">
					<i class="material-icons">fullscreen</i>
				</div>
				<div class="btn-zoom" [title]="labels().CANVAS3D_COMPONENT_ZOOM_IN" (click)="zoomIn()" (keypress)="zoomIn()">
					<i class="material-icons">add</i>
				</div>
				<div class="btn-zoom" [title]="labels().CANVAS3D_COMPONENT_ZOOM_OUT" (click)="zoomOut()" (keypress)="zoomOut()">
					<i class="material-icons">remove</i>
				</div>
			</div>
			}

			<!-- LEFT WIDGET ZOOM FOR MULTIPLE VIEW -->
			@if (isMultipleAP) {
			<div class="widget-zoom second">
				<div class="btn-zoom" [title]="labels().CANVAS3D_COMPONENT_FIT_TO_VIEW" (click)="fitToView()"
					(keypress)="fitToView()">
					<i class="material-icons">fullscreen</i>
				</div>
				<div class="btn-zoom" [title]="labels().CANVAS3D_COMPONENT_ZOOM_IN" (click)="zoomIn()" (keypress)="zoomIn()">
					<i class="material-icons">add</i>
				</div>
				<div class="btn-zoom" [title]="labels().CANVAS3D_COMPONENT_ZOOM_OUT" (click)="zoomOut()" (keypress)="zoomOut()">
					<i class="material-icons">remove</i>
				</div>
			</div>
			}

			<!-- Canvas -->
			<div style="height: 100%" id="canvas-container"></div>

			<layers />
			<messages />

		</div>
	</div>


</div>